import { ReactNode } from "react";
import clsx from "clsx";

export function ScrollSection({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={clsx("scroll-section", className)}>
      <div className="w-full max-w-[960px]">{children}</div>
    </div>
  );
}
